
<ng-container *ngIf="isDebugMode$ | async">
  <ng-content></ng-content>
</ng-container>
